import { gql } from '@common/hooks';

export const TouchTokenQuery = gql`
  query TouchTokenQuery {
    currentMembership {
      id
      authenticationIdleTimeoutInSeconds
      authenticationIdleTimeoutInText
    }
  }
`;

export type TouchTokenQueryResponse = {
  currentMembership: {
    id: string;
    authenticationIdleTimeoutInSeconds: number;
    authenticationIdleTimeoutInText: string;
  };
};
